




















































































































































































































































































































































































import {Vue, Component, Watch, Ref, Prop} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import {DateTime} from "luxon";
import {cloneDeep, isEqual} from "lodash";
import {CollapseTransition} from "vue2-transitions";
import {
  SelectWings,
  DatePickerWings,
  ToggleWings,
  Collapse,
  SpoilerWings,
  TimeoutWings,
  FieldTooltip
} from 'wings-ui-components';
import {SmsTextInputWings} from '@/components/SMS';
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TemplateItem} from '@/store/settings/templates/types';
import {MsgTransports} from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import AdditionalParamsCard from "@/pages/Pages/Templates/AdditionalParamsCard.vue";

@Component({
  components: {
    AdditionalParamsCard,
    FieldTooltip,
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    SmsTextInputWings,
    CollapseTransition,
    TimeoutWings,
  }
})
export default class GenericTemplate extends Vue {
  @Ref('validator') validator: any;
  @Prop() moderation!: boolean;
  @Prop() transport!: MsgTransports;
  @Prop() templateObject!: TemplateItem;

  @Getter("priorityList") priorityList: any;
  @Getter("deliveryTypeList") deliveryTypeList: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("transportsMultichannel") transportsMultichannelList: any;
  @Getter("multichannelTemplates") multichannelTemplatesList: any;

  @Action("getTemplateItem") actionGetTemplateItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getBlacklists") actionGetBlackLists: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getTransportsMultichannel") actionGetTransportsMultichannel: any;
  @Action("getMultichannelTemplates") actionGetMultichannelTemplates: any;

  @Action("saveTemplate") actionSaveTemplate: any;
  @Action("deleteTemplate") actionDeleteTemplate: any;
  @Action("actionLog") actionLog: any;

  private emailTransport: MsgTransports = MsgTransports.EMAIL;
  private pushTransport: MsgTransports = MsgTransports.PUSH;
  private mailNotifyTransport: MsgTransports = MsgTransports.MAILNOTIFY;

  defaultTemplate(): TemplateItem {
    return this.templateObject
  }

  public template = this.defaultTemplate();
  private templateSaved = this.defaultTemplate();
  private weekDays = [
    {value: 'MON'},
    {value: 'TUE'},
    {value: 'WED'},
    {value: 'THU'},
    {value: 'FRI'},
    {value: 'SAT'},
    {value: 'SUN'}
  ];
  private is_cascading = false;
  private multichannel_chanel = '';
  private logObject: ActionLog = {};

  partnersList: any = []
  originatorsList: any = []
  partnerUsersList: any = []
  blacklistsList: any = []
  multichannelTemplateList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({transport: this.transport, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({partner_id: this.template.partner_id, transport: this.transport, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    const items = await this.actionGetPartnerUsers({partner_id: this.template.partner_id, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async getBlacklistsList(filter: any) {
    const items = await this.actionGetBlackLists({partner_user_id: this.template.partner_user_id, ...filter});
    this.blacklistsList = (filter?.page_number > 1) ? this.blacklistsList.concat(items) : items
  }

  async getMultichannelTemplateList(filter: any) {
    let transport = this.transportsMultichannelList.find((item: any) => item.id == this.template.multichannel_id)?.name ?? '';
    const items = await this.actionGetMultichannelTemplates({
      transport: transport.toLowerCase(),
      filter: {
        partner_id: this.template.partner_id,
        is_active: 1,
        ...filter
      }
    });
    this.multichannelTemplateList = (filter?.page_number > 1) ? this.multichannelTemplateList.concat(items) : items
  }

  async created() {
    this.templateSaved= cloneDeep(this.template);
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Template",
          addititional_info: getTranslatedParams(this.template, {'is_active': 'active', 'save_text': 'statistic'})
        }
        const data = await this.actionGetTemplateItem({id: this.$route.params.id, transport: this.transport})
        this.template=Object.assign({},this.template, data);
        this.templateSaved= cloneDeep(Object.assign({},this.template, data));
        this.logObject.object_name = this.template.name;
        this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.$emit('onChangeTemplate', this.template);
      if (this.template.multichannel_template_id || this.template.multichannel_id) {this.is_cascading = true}
      if (this.moderation) this.$emit('onLoadTemplate', this.template.status)

      if (this.template.partner_id) this.partnersList = await this.actionGetPartners({id: this.template.partner_id});
      if (this.template.originator_id) this.originatorsList = await this.actionGetOriginators({id: this.template.originator_id});
      if (this.template.partner_user_id) this.partnerUsersList = await this.actionGetPartnerUsers({id: this.template.partner_user_id});
      if (this.template.blacklist_id) this.blacklistsList = await this.actionGetBlackLists({id: this.template.blacklist_id});

      let transport = this.transportsMultichannelList.find((item: any) => item.id == this.template.multichannel_id)?.name ?? '';
      if (this.template.multichannel_template_id) this.multichannelTemplateList = await this.actionGetMultichannelTemplates({
        transport: transport.toLowerCase(),
        filter: {id: this.template.multichannel_template_id}
      });
    }
    this.actionGetMessageTypes();
  }

  back():void{
    this.$router.push(`/${this.transport.toLowerCase()}/templates/`);
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Template",
            object_name : this.template.name,
            addititional_info: getTranslatedParams(this.template)
          }
          await this.actionSaveTemplate({item: this.template, transport: this.transport})
          await this.actionLog(this.logObject);
          this.templateSaved = this.template;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        reject();
        notifyError(null, this.validator.errors);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Template",
          object_name : this.template.name,
          addititional_info: getTranslatedParams({id: this.template.id})
        }
        await this.actionDeleteTemplate({item: this.template, transport: this.transport});
        await this.actionLog(this.logObject);
        this.templateSaved = this.template;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  get minEndingDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.starting_datetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.starting_datetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.starting_datetime
  }

  get minEndDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.start_datetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.start_datetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.start_datetime
  }

  @Watch('template.start_datetime', {immediate: true})
  onChangeStartDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.send_evenly = 0
    }
  }

  @Watch('template.end_datetime', {immediate: true})
  onChangeEndDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.send_evenly = 0
    }
  }

  @Watch('template.partner_id', {immediate: true})
  async onTemplateChangePartner(val: number, oldVal?: number) {
    if (this.template.partner_id) {
      this.$emit('onPartnerId', this.template.partner_id);
      this.actionGetTransportsMultichannel({transport : this.transport, partner_id: this.template.partner_id});
    }
    if (oldVal && val !== oldVal) {
      this.template.partner_user_id = null;
      this.template.blacklist_id = null;
      this.template.originator_id = null;
      this.template.multichannel_id = null;
      this.template.multichannel_template_id = null;
    }
  }

  @Watch('template.multichannel_id', {immediate: true})
  async onTemplateChangeMultichannel(val: number, oldVal?: number) {
    if (oldVal && val !== oldVal) {
      this.template.multichannel_template_id = null;
    }
  }

  @Watch('is_cascading', {immediate: true})
  onChangeIsCascading(val?: boolean) {
    if (!val) {
      this.template.multichannel_id = null;
      this.template.multichannel_template_id = null;
      this.template.multichannel_timeout = null;
      this.template.multichannel_positive_sending = null;
    }
  }

  beforeLeave(to: any, from: any, next: any) {
    const isChange = !isEqual(this.template, this.templateSaved);
    if (to.name) notifyConfirm(isChange, this.onSaveItem, next);
    else next();
  }
}
